import { createSafeContext } from '@/lib/context';

export type ListingFiltersType = 'PLP' | 'SEARCH_VIEW';
export type ListingFiltersProviderContext = {
  listingFiltersType: ListingFiltersType;
};
export const { Provider, useContext: useListingFiltersProvider } =
  createSafeContext<ListingFiltersProviderContext>(
    'useListingFiltersProvider must be used inside a ListingFiltersProvider',
  );
